import React from 'react'
import InterfaceWrapper from './components/InterfaceWrapper'
import InvoicesMain from './components/InvoicesMain'

const Invoices = props => {
  return <InterfaceWrapper Main={InvoicesMain} {...props} />
}

export default Invoices
